import React from "react";
import ReactMarkdown from "react-markdown";
import { Bot, Loader2, User } from "lucide-react";

/** A single message bubble in the delivery-agent chat. */
export default function ChatBubble({ role, content, pending }) {
  const isUser = role === "user";
  return (
    <div
      data-testid={`delivery-msg-${role}`}
      className={`flex gap-3 ${isUser ? "flex-row-reverse" : ""}`}
    >
      <span
        className={`inline-flex h-7 w-7 shrink-0 grid place-items-center rounded-full text-sand-100 ${
          isUser ? "bg-clay" : "bg-ink-deep"
        }`}
      >
        {isUser ? <User size={12} /> : <Bot size={12} />}
      </span>
      <div
        className={`max-w-[88%] rounded-2xl px-4 py-3 text-[13.5px] leading-relaxed ${
          isUser
            ? "bg-clay/10 text-ink border border-clay/20"
            : "bg-sand-100 text-ink border border-sand-300"
        }`}
      >
        {pending ? (
          <span className="inline-flex items-center gap-2 text-ink-muted">
            <Loader2 size={12} className="animate-spin" /> Drafting…
          </span>
        ) : (
          <article className="prose prose-sm prose-ink max-w-none whitespace-pre-wrap break-words">
            <ReactMarkdown>{content}</ReactMarkdown>
          </article>
        )}
      </div>
    </div>
  );
}
